import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { defaultsDeep, endsWith, repeat } from "lodash"
import * as Symbols from "../../constants/symbols"

export const padDecimals = (amount: number, places: number): string => {
    const amountString = String(amount)
    const dotIndex = amountString.lastIndexOf(".")
    const add = dotIndex !== -1 ? places - (amountString.length - dotIndex - 1) : places

    if (add > 0) {
        return amountString + (dotIndex !== -1 ? "" : ".") + repeat("0", add)
    } else {
        return amountString
    }
}

export const roundDecimals = (amount: Maybe<number>, places: number = 0): Maybe<number> => {
    if (amount !== null && amount !== undefined) {
        const coefficient = Math.pow(10, 2 - places)

        return Math.round(amount / coefficient) * coefficient
    } else {
        return null
    }
}
export const formatPrice = (
    price: Maybe<number>,
    options: {
        withPlus?: boolean
        zeroIsNull?: boolean
        notDecimal?: boolean
    } = {
        withPlus: false,
        zeroIsNull: false,
        notDecimal: false,
    }
): string => {
    if (price == null || (options.zeroIsNull && price === 0)) {
        return Symbols.MDash
    }

    let sign = ""

    if (price < 0) {
        sign = Symbols.Minus
    } else if (price > 0 && options.withPlus) {
        sign = Symbols.Plus
    }

    const output =
        sign +
        (Math.abs(price) / 100).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        })
    return endsWith(output, ".00") && options.notDecimal ? output.substring(0, output.length - 3) : output
}
export const formatPriceOrPercentage = (
    price: Maybe<number>,
    percentage: Maybe<number>,
    options: {
        withPlus?: boolean
        zeroIsNull?: boolean
        notDecimal?: boolean
    } = {
        withPlus: false,
        zeroIsNull: false,
        notDecimal: false,
    }
): string => {
    return price != null ? formatPrice(price, options) : formatPercentage(percentage, options)
}

export type FormatPercentageParameters = {
    withPlus?: boolean
    places?: number
    zeroIsNull?: boolean
    alwaysDecimal?: boolean
}
export const formatPercentage = (percentage: Maybe<number>, _options?: Maybe<FormatPercentageParameters>): string => {
    const options = defaultsDeep(_options, {
        withPlus: false,
        zeroIsNull: false,
        alwaysDecimal: false,
        places: 3,
    })

    if (percentage == null || (options.zeroIsNull && percentage === 0)) {
        return Symbols.MDash
    }

    let sign = ""

    if (percentage < 0) {
        sign = Symbols.Minus
    } else if (percentage > 0 && options.withPlus) {
        sign = Symbols.Plus
    }

    const exp = Math.pow(10, options.places)

    const rounded = Math.abs(Math.round((percentage / 1000) * exp) / exp)
    const expanded = options.alwaysDecimal ? padDecimals(rounded, options.places) : rounded
    return `${sign}${expanded}%`
}
export const parseNumber = (value: string, decimal: number = 2): number => {
    let priceValueArray = value.replace(/[^0-9.]/g, "").split("")
    let decimalIndex = priceValueArray.indexOf(".")
    const zeroArrays = new Array(decimal).fill("0")

    if (decimalIndex === -1) {
        priceValueArray = [...priceValueArray, ".", ...zeroArrays]
        decimalIndex = priceValueArray.indexOf(".")
    } else {
        priceValueArray = [...priceValueArray, ...zeroArrays]
    }

    const newValue = [
        ...priceValueArray.slice(0, decimalIndex),
        ...priceValueArray.slice(decimalIndex + 1, decimalIndex + decimal + 1),
    ]
    return parseInt(newValue.join(""), 10)
}
